const X = {
  KM: 1,
  M: 2,
  MI: 3,
  YD: 4,
  FT: 5
}, S = {
  1: "km",
  2: "m",
  3: "mi",
  4: "yd",
  5: "ft"
};
function y(e, a = "") {
  return S[e] || a || "";
}
function k(e) {
  let a = 0;
  for (const [r, m] of Object.entries(S))
    if (m === e) {
      a = Number(r);
      break;
    }
  return a;
}
function j(e = 0, a = 2) {
  return Number((e / 1e3).toFixed(a));
}
function J(e = 0, a = 2) {
  return Number((e / 1e3 / 1.609344).toFixed(a));
}
function $(e = 0, a = 2) {
  return Number((e / 1.609344).toFixed(a));
}
function z(e = 0, a = 2) {
  return Number((e / 1.609344).toFixed(a));
}
function q(e = 0, a = 2) {
  return Number((e * 1e3).toFixed(a));
}
function Q(e = 0, a = 2) {
  return Number((e * 1e3 * 100).toFixed(a));
}
function Z(e = 0, a = 2) {
  return Number((e * 1.609344).toFixed(a));
}
function w(e = 0, a = 2) {
  return Number((e * 1.609344 * 1e3).toFixed(a));
}
function Y(e = 0, a = 2) {
  return Number((e * 1.609344 * 1e3 * 100).toFixed(a));
}
function W(e = 0, a = 2) {
  return Number((e / 0.9144).toFixed(a));
}
function P(e = 0, a = 2) {
  return Number((e / 0.3048).toFixed(a));
}
function ee(e = 0, a = 2) {
  return Number((e * 0.3048).toFixed(a));
}
function ae(e = 0) {
  const a = e / 2.54;
  let r = Math.floor(a / 12), m = Math.round(a % 12);
  return m === 12 && (r++, m = 0), `${r}'${m < 10 ? "0" : ""}${m}"`;
}
function re(e = 0, a = 2) {
  return Number((e / 100 / 0.3048).toFixed(a));
}
function de(e = 0, a = 2) {
  return Number((e / 2.54).toFixed(a));
}
function me(e = 0, a = 2) {
  return Number((e * 2.54).toFixed(a));
}
function oe(e = 0, a = 2) {
  return Number((e * 0.9144 / 1e3 / 1.609344).toFixed(a));
}
function ne(e = 0, a = 2) {
  return Number((e * 0.9144).toFixed(a));
}
function ge(e = 0, a = 2) {
  return Number((e * 0.9144).toFixed(a));
}
function ce(e = 0, a = 2) {
  return Number((e * 0.9144 * 100).toFixed(a));
}
const te = (e) => (typeof e == "number" && (e = e === 0), e ? "℃" : "℉"), Ne = (e = 0, a = 2) => (e * 9 / 5 + 32).toFixed(a), Ge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  convertValueC2F: Ne,
  getUnit: te
}, Symbol.toStringTag, { value: "Module" })), Ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TARGET_UNIT_TYPE: X,
  convertCmToFt: ae,
  distanceCM2FT: re,
  distanceCM2inch: de,
  distanceFT2m: ee,
  distanceInch2CM: me,
  distanceKM2mile: $,
  distanceKm2Cm: Q,
  distanceKm2Mi: z,
  distanceKm2m: q,
  distanceM2Km: j,
  distanceM2Mile: J,
  distanceM2Yard: W,
  distanceM2ft: P,
  distanceMile2Cm: Y,
  distanceMile2Km: Z,
  distanceMile2M: w,
  distanceYard2Cm: ce,
  distanceYard2M: ne,
  distanceYard2Mile: oe,
  distanceYard2m: ge,
  getTargetUnitNameByType: y,
  getTargetUnitTypeByName: k,
  targetUnitName: S,
  temperature: Ge
}, Symbol.toStringTag, { value: "Module" })), p = {
  // 优胜美地
  Rock_YDS: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    {
      grade: 1,
      commonGrade: [2, 3, 4, 5],
      gradeName: "Low 5th（简单攀爬）",
      gradeNameI18n: "H5048"
    },
    { grade: 2, commonGrade: [6], gradeName: "5.6" },
    { grade: 3, commonGrade: [7], gradeName: "5.7" },
    { grade: 4, commonGrade: [8], gradeName: "5.8" },
    { grade: 5, commonGrade: [9], gradeName: "5.9" },
    { grade: 6, commonGrade: [10], gradeName: "5.10a" },
    { grade: 7, commonGrade: [11], gradeName: "5.10b" },
    { grade: 8, commonGrade: [12], gradeName: "5.10c" },
    { grade: 9, commonGrade: [13], gradeName: "5.10d" },
    { grade: 10, commonGrade: [14], gradeName: "5.11a" },
    { grade: 11, commonGrade: [15], gradeName: "5.11b" },
    { grade: 12, commonGrade: [16], gradeName: "5.11c" },
    { grade: 13, commonGrade: [17], gradeName: "5.11d" },
    { grade: 14, commonGrade: [18], gradeName: "5.12a" },
    { grade: 15, commonGrade: [19], gradeName: "5.12b" },
    { grade: 16, commonGrade: [20], gradeName: "5.12c" },
    { grade: 17, commonGrade: [21], gradeName: "5.12d" },
    { grade: 18, commonGrade: [22], gradeName: "5.13a" },
    { grade: 19, commonGrade: [23], gradeName: "5.13b" },
    { grade: 20, commonGrade: [24], gradeName: "5.13c" },
    { grade: 21, commonGrade: [25], gradeName: "5.13d" },
    { grade: 22, commonGrade: [26], gradeName: "5.14a" },
    { grade: 23, commonGrade: [27], gradeName: "5.14b" },
    { grade: 24, commonGrade: [28], gradeName: "5.14c" },
    { grade: 25, commonGrade: [29], gradeName: "5.14d" },
    { grade: 26, commonGrade: [30], gradeName: "5.15a" }
  ],
  // 法式
  Rock_French: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    {
      grade: 1,
      commonGrade: [2],
      gradeName: "Easy （简单攀爬）",
      gradeNameI18n: "H5048"
    },
    { grade: 2, commonGrade: [3], gradeName: "4a" },
    { grade: 3, commonGrade: [4], gradeName: "4b" },
    { grade: 4, commonGrade: [5], gradeName: "4c" },
    { grade: 5, commonGrade: [6], gradeName: "5a" },
    { grade: 6, commonGrade: [7], gradeName: "5b" },
    { grade: 7, commonGrade: [8], gradeName: "5c" },
    { grade: 8, commonGrade: [9], gradeName: "6a" },
    { grade: 9, commonGrade: [10], gradeName: "6a+" },
    { grade: 10, commonGrade: [11], gradeName: "6b" },
    { grade: 11, commonGrade: [12], gradeName: "6b+" },
    { grade: 12, commonGrade: [13], gradeName: "6c" },
    { grade: 13, commonGrade: [14], gradeName: "6c+" },
    { grade: 14, commonGrade: [15], gradeName: "7a" },
    { grade: 15, commonGrade: [16], gradeName: "7a+" },
    { grade: 16, commonGrade: [17], gradeName: "7b" },
    { grade: 17, commonGrade: [18], gradeName: "7b+" },
    { grade: 18, commonGrade: [19], gradeName: "7c" },
    { grade: 19, commonGrade: [20], gradeName: "7c+" },
    { grade: 20, commonGrade: [21], gradeName: "8a" },
    { grade: 21, commonGrade: [22], gradeName: "8a+" },
    { grade: 22, commonGrade: [23], gradeName: "8b" },
    { grade: 23, commonGrade: [24], gradeName: "8b+" },
    { grade: 24, commonGrade: [25], gradeName: "8c" },
    { grade: 25, commonGrade: [26], gradeName: "8c+" },
    { grade: 26, commonGrade: [27], gradeName: "9a" },
    { grade: 27, commonGrade: [28], gradeName: "9a+" },
    { grade: 28, commonGrade: [29], gradeName: "9b" },
    { grade: 29, commonGrade: [30], gradeName: "9b+" }
  ],
  // 器械攀岩
  Rock_Aid: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    { grade: 1, commonGrade: [2, 3, 4, 5, 6, 7, 8, 9], gradeName: "A1" },
    { grade: 2, commonGrade: [10, 11, 12, 13, 14], gradeName: "A2" },
    { grade: 3, commonGrade: [15, 16, 17, 18, 19], gradeName: "A3" },
    { grade: 4, commonGrade: [20, 21, 22, 23, 24], gradeName: "A4" },
    { grade: 5, commonGrade: [25, 26, 27, 28, 29, 30], gradeName: "A5" }
  ],
  // 攀冰
  Ice_Grades: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    { grade: 1, commonGrade: [2, 3, 4, 5], gradeName: "WI1" },
    { grade: 2, commonGrade: [6, 7, 8, 9], gradeName: "WI2" },
    { grade: 3, commonGrade: [10, 11, 12, 13], gradeName: "WI3" },
    { grade: 4, commonGrade: [14, 15, 16, 17], gradeName: "WI4" },
    { grade: 5, commonGrade: [18, 19, 20, 21], gradeName: "WI5" },
    { grade: 6, commonGrade: [22, 23, 24, 25], gradeName: "WI6" },
    { grade: 7, commonGrade: [26, 27, 28, 29, 30], gradeName: "WI7" }
  ],
  // 冰岩混合
  Mix_Grades: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    { grade: 1, commonGrade: [2], gradeName: "M1" },
    { grade: 2, commonGrade: [3], gradeName: "M2" },
    { grade: 3, commonGrade: [4], gradeName: "M3" },
    { grade: 4, commonGrade: [5], gradeName: "M4" },
    { grade: 5, commonGrade: [6, 7], gradeName: "M5" },
    { grade: 6, commonGrade: [8, 9], gradeName: "M6" },
    { grade: 7, commonGrade: [10, 11], gradeName: "M7" },
    { grade: 8, commonGrade: [12, 13], gradeName: "M8" },
    { grade: 9, commonGrade: [14, 15], gradeName: "M9" },
    { grade: 10, commonGrade: [16, 17], gradeName: "M10" },
    { grade: 11, commonGrade: [18, 19], gradeName: "M11" },
    { grade: 12, commonGrade: [20, 21], gradeName: "M12" },
    { grade: 13, commonGrade: [22, 23], gradeName: "M13" },
    { grade: 14, commonGrade: [24, 25], gradeName: "M14" },
    { grade: 15, commonGrade: [26, 27], gradeName: "M15" },
    { grade: 16, commonGrade: [28, 29, 30], gradeName: "M16" }
  ],
  // 英式
  UK_TRAD: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    {
      grade: 1,
      commonGrade: [2, 3],
      gradeName: "VD"
    },
    { grade: 2, commonGrade: [4], gradeName: "S" },
    { grade: 3, commonGrade: [5], gradeName: "HS" },
    { grade: 4, commonGrade: [6], gradeName: "VS" },
    { grade: 5, commonGrade: [7], gradeName: "HVS" },
    { grade: 6, commonGrade: [8, 9], gradeName: "E1" },
    { grade: 7, commonGrade: [10, 11], gradeName: "E2" },
    { grade: 8, commonGrade: [12, 13], gradeName: "E3" },
    { grade: 9, commonGrade: [14, 15], gradeName: "E4" },
    { grade: 10, commonGrade: [16, 17], gradeName: "E5" },
    { grade: 11, commonGrade: [18, 19], gradeName: "E6" },
    { grade: 12, commonGrade: [20, 21], gradeName: "E7" },
    { grade: 13, commonGrade: [22], gradeName: "E8" },
    { grade: 14, commonGrade: [23], gradeName: "E9" },
    { grade: 15, commonGrade: [24], gradeName: "E10" },
    { grade: 16, commonGrade: [25], gradeName: "E11" },
    { grade: 17, commonGrade: [26, 27, 28, 29, 30], gradeName: "E12" }
  ],
  // 国际登山与攀岩联盟
  UIAA: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    { grade: 1, commonGrade: [2], gradeName: "Easy （简单攀爬）", gradeNameI18n: "H5048" },
    { grade: 2, commonGrade: [3], gradeName: "IV" },
    { grade: 3, commonGrade: [4], gradeName: "IV+" },
    { grade: 4, commonGrade: [5], gradeName: "V" },
    { grade: 5, commonGrade: [6], gradeName: "V+" },
    { grade: 6, commonGrade: [7], gradeName: "VI-" },
    { grade: 7, commonGrade: [8], gradeName: "VI" },
    { grade: 8, commonGrade: [9], gradeName: "VI+" },
    { grade: 9, commonGrade: [10], gradeName: "VII-" },
    { grade: 10, commonGrade: [11], gradeName: "VII" },
    { grade: 11, commonGrade: [12], gradeName: "VII+" },
    { grade: 12, commonGrade: [13, 14], gradeName: "VIII-" },
    { grade: 13, commonGrade: [15], gradeName: "VIII" },
    { grade: 14, commonGrade: [16, 17], gradeName: "VIII+" },
    { grade: 15, commonGrade: [18], gradeName: "IX-" },
    { grade: 16, commonGrade: [19], gradeName: "IX" },
    { grade: 17, commonGrade: [20, 21], gradeName: "IX+" },
    { grade: 18, commonGrade: [22], gradeName: "X-" },
    { grade: 19, commonGrade: [23], gradeName: "X" },
    { grade: 20, commonGrade: [24, 25], gradeName: "X+" },
    { grade: 21, commonGrade: [26], gradeName: "XI-" },
    { grade: 22, commonGrade: [27], gradeName: "XI" },
    { grade: 23, commonGrade: [28], gradeName: "XI+" },
    { grade: 24, commonGrade: [29], gradeName: "XII-" },
    { grade: 25, commonGrade: [30], gradeName: "XII" }
  ],
  // 澳大利亚
  EWBANK: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "Jug the rope（上升器跟攀）",
      gradeNameI18n: "H5047"
    },
    { grade: 1, commonGrade: [2], gradeName: "Easy （简单攀爬）", gradeNameI18n: "H5048" },
    { grade: 2, commonGrade: [3], gradeName: "12" },
    { grade: 3, commonGrade: [4], gradeName: "13" },
    { grade: 4, commonGrade: [5], gradeName: "14" },
    { grade: 5, commonGrade: [6], gradeName: "15" },
    { grade: 6, commonGrade: [7], gradeName: "16" },
    { grade: 7, commonGrade: [8], gradeName: "17" },
    { grade: 8, commonGrade: [9], gradeName: "18" },
    { grade: 9, commonGrade: [10], gradeName: "19" },
    { grade: 10, commonGrade: [11], gradeName: "20" },
    { grade: 11, commonGrade: [12], gradeName: "21" },
    { grade: 12, commonGrade: [13], gradeName: "22" },
    { grade: 13, commonGrade: [14], gradeName: "23" },
    { grade: 14, commonGrade: [15], gradeName: "24" },
    { grade: 15, commonGrade: [16], gradeName: "25" },
    { grade: 16, commonGrade: [17], gradeName: "26" },
    { grade: 17, commonGrade: [18], gradeName: "27" },
    { grade: 18, commonGrade: [19], gradeName: "28" },
    { grade: 19, commonGrade: [20], gradeName: "29" },
    { grade: 20, commonGrade: [21], gradeName: "30" },
    { grade: 21, commonGrade: [22], gradeName: "31" },
    { grade: 22, commonGrade: [23], gradeName: "32" },
    { grade: 23, commonGrade: [24], gradeName: "33" },
    { grade: 24, commonGrade: [25], gradeName: "34" },
    { grade: 25, commonGrade: [26], gradeName: "35" },
    { grade: 26, commonGrade: [27], gradeName: "36" },
    { grade: 27, commonGrade: [28], gradeName: "37" },
    { grade: 28, commonGrade: [29], gradeName: "38" },
    { grade: 29, commonGrade: [30], gradeName: "39" }
  ]
}, u = {
  // 优胜美地
  Rock_YDS: [
    { grade: 0, commonGrade: [1, 2, 3, 4], gradeName: "5.6" },
    { grade: 1, commonGrade: [5], gradeName: "5.7" },
    { grade: 2, commonGrade: [6], gradeName: "5.8" },
    { grade: 3, commonGrade: [7], gradeName: "5.9" },
    { grade: 4, commonGrade: [8], gradeName: "5.10a" },
    { grade: 5, commonGrade: [9], gradeName: "5.10b" },
    { grade: 6, commonGrade: [10], gradeName: "5.10c" },
    { grade: 7, commonGrade: [11], gradeName: "5.10d" },
    { grade: 8, commonGrade: [12], gradeName: "5.11a" },
    { grade: 9, commonGrade: [13], gradeName: "5.11b" },
    { grade: 10, commonGrade: [14], gradeName: "5.11c" },
    { grade: 11, commonGrade: [15], gradeName: "5.11d" },
    { grade: 12, commonGrade: [16], gradeName: "5.12a" },
    { grade: 13, commonGrade: [17], gradeName: "5.12b" },
    { grade: 14, commonGrade: [18], gradeName: "5.12c" },
    { grade: 15, commonGrade: [19], gradeName: "5.12d" },
    { grade: 16, commonGrade: [20], gradeName: "5.13a" },
    { grade: 17, commonGrade: [21], gradeName: "5.13b" },
    { grade: 18, commonGrade: [22], gradeName: "5.13c" },
    { grade: 19, commonGrade: [23], gradeName: "5.13d" },
    { grade: 20, commonGrade: [24], gradeName: "5.14a" },
    { grade: 21, commonGrade: [25], gradeName: "5.14b" },
    { grade: 22, commonGrade: [26], gradeName: "5.14c" },
    { grade: 23, commonGrade: [27], gradeName: "5.14d" },
    { grade: 24, commonGrade: [28], gradeName: "5.15a" }
  ],
  // 法式
  Rock_French: [
    { grade: 0, commonGrade: [1], gradeName: "4a" },
    { grade: 1, commonGrade: [2], gradeName: "4b" },
    { grade: 2, commonGrade: [3], gradeName: "4c" },
    { grade: 3, commonGrade: [4], gradeName: "5a" },
    { grade: 4, commonGrade: [5], gradeName: "5b" },
    { grade: 5, commonGrade: [6], gradeName: "5c" },
    { grade: 6, commonGrade: [7], gradeName: "6a" },
    { grade: 7, commonGrade: [8], gradeName: "6a+" },
    { grade: 8, commonGrade: [9], gradeName: "6b" },
    { grade: 9, commonGrade: [10], gradeName: "6b+" },
    { grade: 10, commonGrade: [11], gradeName: "6c" },
    { grade: 11, commonGrade: [12], gradeName: "6c+" },
    { grade: 12, commonGrade: [13], gradeName: "7a" },
    { grade: 13, commonGrade: [14], gradeName: "7a+" },
    { grade: 14, commonGrade: [15], gradeName: "7b" },
    { grade: 15, commonGrade: [16], gradeName: "7b+" },
    { grade: 16, commonGrade: [17], gradeName: "7c" },
    { grade: 17, commonGrade: [18], gradeName: "7c+" },
    { grade: 18, commonGrade: [19], gradeName: "8a" },
    { grade: 19, commonGrade: [20], gradeName: "8a+" },
    { grade: 20, commonGrade: [21], gradeName: "8b" },
    { grade: 21, commonGrade: [22], gradeName: "8b+" },
    { grade: 22, commonGrade: [23], gradeName: "8c" },
    { grade: 23, commonGrade: [24], gradeName: "8c+" },
    { grade: 24, commonGrade: [25], gradeName: "9a" },
    { grade: 25, commonGrade: [26], gradeName: "9a+" },
    { grade: 26, commonGrade: [27], gradeName: "9b" },
    { grade: 27, commonGrade: [28], gradeName: "9b+" }
  ],
  // 国际登山与攀岩联盟
  UIAA: [
    { grade: 0, commonGrade: [1], gradeName: "IV" },
    { grade: 1, commonGrade: [2], gradeName: "IV+" },
    { grade: 2, commonGrade: [3], gradeName: "V" },
    { grade: 3, commonGrade: [4], gradeName: "V+" },
    { grade: 4, commonGrade: [5], gradeName: "VI-" },
    { grade: 5, commonGrade: [6], gradeName: "VI" },
    { grade: 6, commonGrade: [7], gradeName: "VI+" },
    { grade: 7, commonGrade: [8], gradeName: "VII-" },
    { grade: 8, commonGrade: [9], gradeName: "VII" },
    { grade: 9, commonGrade: [10], gradeName: "VII+" },
    { grade: 10, commonGrade: [11, 12], gradeName: "VIII-" },
    { grade: 11, commonGrade: [13], gradeName: "VIII" },
    { grade: 12, commonGrade: [14, 15], gradeName: "VIII+" },
    { grade: 13, commonGrade: [16], gradeName: "IX-" },
    { grade: 14, commonGrade: [17], gradeName: "IX" },
    { grade: 15, commonGrade: [18, 19], gradeName: "IX+" },
    { grade: 16, commonGrade: [20], gradeName: "X-" },
    { grade: 17, commonGrade: [21], gradeName: "X" },
    { grade: 18, commonGrade: [22, 23], gradeName: "X+" },
    { grade: 19, commonGrade: [24], gradeName: "XI-" },
    { grade: 20, commonGrade: [25], gradeName: "XI" },
    { grade: 21, commonGrade: [26], gradeName: "XI+" },
    { grade: 22, commonGrade: [27], gradeName: "XII-" },
    { grade: 23, commonGrade: [28], gradeName: "XII" }
  ],
  // 澳大利亚
  EWBANK: [
    { grade: 0, commonGrade: [1], gradeName: "12" },
    { grade: 1, commonGrade: [2], gradeName: "13" },
    { grade: 2, commonGrade: [3], gradeName: "14" },
    { grade: 3, commonGrade: [4], gradeName: "15" },
    { grade: 4, commonGrade: [5], gradeName: "16" },
    { grade: 5, commonGrade: [6], gradeName: "17" },
    { grade: 6, commonGrade: [7], gradeName: "18" },
    { grade: 7, commonGrade: [8], gradeName: "19" },
    { grade: 8, commonGrade: [9], gradeName: "20" },
    { grade: 9, commonGrade: [10], gradeName: "21" },
    { grade: 10, commonGrade: [11], gradeName: "22" },
    { grade: 11, commonGrade: [12], gradeName: "23" },
    { grade: 12, commonGrade: [13], gradeName: "24" },
    { grade: 13, commonGrade: [14], gradeName: "25" },
    { grade: 14, commonGrade: [15], gradeName: "26" },
    { grade: 15, commonGrade: [16], gradeName: "27" },
    { grade: 16, commonGrade: [17], gradeName: "28" },
    { grade: 17, commonGrade: [18], gradeName: "29" },
    { grade: 18, commonGrade: [19], gradeName: "30" },
    { grade: 19, commonGrade: [20], gradeName: "31" },
    { grade: 20, commonGrade: [21], gradeName: "32" },
    { grade: 21, commonGrade: [22], gradeName: "33" },
    { grade: 22, commonGrade: [23], gradeName: "34" },
    { grade: 23, commonGrade: [24], gradeName: "35" },
    { grade: 24, commonGrade: [25], gradeName: "36" },
    { grade: 25, commonGrade: [26], gradeName: "37" },
    { grade: 26, commonGrade: [27], gradeName: "38" },
    { grade: 27, commonGrade: [28], gradeName: "39" }
  ],
  // V-Scale（V等级抱石）
  V_SCALE: [
    { grade: 0, commonGrade: [1, 2, 3, 4, 5, 6], gradeName: "V0" },
    { grade: 1, commonGrade: [7], gradeName: "V1" },
    { grade: 2, commonGrade: [8], gradeName: "V2" },
    { grade: 3, commonGrade: [9, 10], gradeName: "V3" },
    { grade: 4, commonGrade: [11, 12], gradeName: "V4" },
    { grade: 5, commonGrade: [13, 14], gradeName: "V5" },
    { grade: 6, commonGrade: [15, 16], gradeName: "V6" },
    { grade: 7, commonGrade: [17], gradeName: "V7" },
    { grade: 8, commonGrade: [18], gradeName: "V8" },
    { grade: 9, commonGrade: [19], gradeName: "V9" },
    { grade: 10, commonGrade: [20], gradeName: "V10" },
    { grade: 11, commonGrade: [21], gradeName: "V11" },
    { grade: 12, commonGrade: [22], gradeName: "V12" },
    { grade: 13, commonGrade: [23], gradeName: "V13" },
    { grade: 14, commonGrade: [24], gradeName: "V14" },
    { grade: 15, commonGrade: [25], gradeName: "V15" },
    { grade: 16, commonGrade: [26], gradeName: "V16" },
    { grade: 17, commonGrade: [27, 28], gradeName: "V17" }
  ],
  // Font Scale（法式抱石）
  FONT_SCALE: [
    { grade: 0, commonGrade: [1, 2, 3, 4, 5, 6], gradeName: "4" },
    { grade: 1, commonGrade: [7], gradeName: "5" },
    { grade: 2, commonGrade: [8], gradeName: "5+" },
    { grade: 3, commonGrade: [9], gradeName: "6A" },
    { grade: 4, commonGrade: [10], gradeName: "6A+" },
    { grade: 5, commonGrade: [11], gradeName: "6B" },
    { grade: 6, commonGrade: [12], gradeName: "6B+" },
    { grade: 7, commonGrade: [13], gradeName: "6C" },
    { grade: 8, commonGrade: [14], gradeName: "6C+" },
    { grade: 9, commonGrade: [15], gradeName: "7A" },
    { grade: 10, commonGrade: [16], gradeName: "7A+" },
    { grade: 11, commonGrade: [17], gradeName: "7B" },
    { grade: 12, commonGrade: [18], gradeName: "7B+" },
    { grade: 13, commonGrade: [19], gradeName: "7C" },
    { grade: 14, commonGrade: [20], gradeName: "7C+" },
    { grade: 15, commonGrade: [21], gradeName: "8A" },
    { grade: 16, commonGrade: [22], gradeName: "8A+" },
    { grade: 17, commonGrade: [23], gradeName: "8B" },
    { grade: 18, commonGrade: [24], gradeName: "8B+" },
    { grade: 19, commonGrade: [25], gradeName: "8C" },
    { grade: 20, commonGrade: [26], gradeName: "8C+" },
    { grade: 21, commonGrade: [27, 28], gradeName: "9A" }
  ]
}, l = {
  // V等级抱石
  V_SCALE: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "V0"
    },
    { grade: 1, commonGrade: [2], gradeName: "V1" },
    { grade: 2, commonGrade: [3], gradeName: "V2" },
    { grade: 3, commonGrade: [4, 5], gradeName: "V3" },
    { grade: 4, commonGrade: [6, 7], gradeName: "V4" },
    { grade: 5, commonGrade: [8, 9], gradeName: "V5" },
    { grade: 6, commonGrade: [10, 11], gradeName: "V6" },
    { grade: 7, commonGrade: [12], gradeName: "V7" },
    { grade: 8, commonGrade: [13], gradeName: "V8" },
    { grade: 9, commonGrade: [14], gradeName: "V9" },
    { grade: 10, commonGrade: [15], gradeName: "V10" },
    { grade: 11, commonGrade: [16], gradeName: "V11" },
    { grade: 12, commonGrade: [17], gradeName: "V12" },
    { grade: 13, commonGrade: [18], gradeName: "V13" },
    { grade: 14, commonGrade: [19], gradeName: "V14" },
    { grade: 15, commonGrade: [20], gradeName: "V15" },
    { grade: 16, commonGrade: [21], gradeName: "V16" },
    { grade: 17, commonGrade: [22], gradeName: "V17" }
  ],
  // 法式抱石
  FONT_SCALE: [
    {
      grade: 0,
      commonGrade: [1],
      gradeName: "4"
    },
    { grade: 1, commonGrade: [2], gradeName: "5" },
    { grade: 2, commonGrade: [3], gradeName: "5+" },
    { grade: 3, commonGrade: [4], gradeName: "6A" },
    { grade: 4, commonGrade: [5], gradeName: "6A+" },
    { grade: 5, commonGrade: [6], gradeName: "6B" },
    { grade: 6, commonGrade: [7], gradeName: "6B+" },
    { grade: 7, commonGrade: [8], gradeName: "6C" },
    { grade: 8, commonGrade: [9], gradeName: "6C+" },
    { grade: 9, commonGrade: [10], gradeName: "7A" },
    { grade: 10, commonGrade: [11], gradeName: "7A+" },
    { grade: 11, commonGrade: [12], gradeName: "7B" },
    { grade: 12, commonGrade: [13], gradeName: "7B+" },
    { grade: 13, commonGrade: [14], gradeName: "7C" },
    { grade: 14, commonGrade: [15], gradeName: "7C+" },
    { grade: 15, commonGrade: [16], gradeName: "8A" },
    { grade: 16, commonGrade: [17], gradeName: "8A+" },
    { grade: 17, commonGrade: [18], gradeName: "8B" },
    { grade: 18, commonGrade: [19], gradeName: "8B+" },
    { grade: 19, commonGrade: [20], gradeName: "8C" },
    { grade: 20, commonGrade: [21], gradeName: "8C+" },
    { grade: 21, commonGrade: [22], gradeName: "9A" }
  ]
}, _ = {
  ...u,
  ...l
}, E = [
  // 1 优胜美地
  { val: 1, name: "Rock_YDS", title: "优胜美地", i18n: "S4661" },
  // 2 法式
  { val: 2, name: "Rock_French", title: "法式", i18n: "S4662" },
  // 3 器械攀岩
  { val: 3, name: "Rock_Aid", title: "器械攀岩" },
  // 4 攀冰
  { val: 4, name: "Ice_Grades", title: "攀冰" },
  // 5 冰岩混合
  { val: 5, name: "Mix_Grades", title: "冰岩混合" },
  // 6 英式
  { val: 6, name: "UK_TRAD", title: "英式" },
  // 7 V等级抱石
  { val: 7, name: "V_SCALE", title: "V等级抱石", i18n: "S4665" },
  // 8 法式抱石
  { val: 8, name: "FONT_SCALE", title: "法式抱石", i18n: "S4666" },
  // 9 国际登山与攀岩联盟
  { val: 9, name: "UIAA", title: "国际登山与攀岩联盟", i18n: "S4663" },
  // 10 澳大利亚
  { val: 10, name: "EWBANK", title: "澳大利亚", i18n: "S4664" }
], G = E.reduce((e, a) => (e[a.val] = a, e), {}), L = [
  //V等级抱石
  7,
  //法式抱石
  8
], h = [
  // 优胜美地
  1,
  // 法式
  2,
  //国际登山与攀岩联盟
  9,
  //澳大利亚
  10
], F = [
  {
    i18n: "H9081",
    color1: "#FF5F48",
    color2: "#C63C28",
    value: 0
  },
  {
    i18n: "H9077",
    color1: "#40D4CF",
    color2: "#13828B",
    value: 1
  },
  {
    i18n: "H9078",
    color1: "#2AC344",
    color2: "#0C802D",
    value: 2
  },
  {
    i18n: "H9079",
    color1: "#FBE94A",
    color2: "#CFB323",
    value: 3
  },
  // 未攀登, 不绘制
  // {
  //   i18n: 'H9080',
  //   color1: '#6A6D7C',
  //   color2: '#2C3146',
  //   value: 4,
  //   nochart: true,
  // },
  // 未记录 unrecorded
  {
    i18n: "H9083",
    color1: "#6A6D7C",
    color2: "#2C3146",
    value: 255
  }
], ie = F.reduce((e, a) => (e[a.value] = a, e), {}), ue = "IndoorClimbGrade";
function V(e) {
  return e === 6 || e === 800;
}
function A(e) {
  return e === 7 || e === 801;
}
function B(e) {
  return V(e) || A(e);
}
function le(e) {
  return ["IndoorClimb", "Bouldering"].includes(e);
}
function T(e) {
  var a;
  return ((a = G[e]) == null ? void 0 : a.name) || "";
}
function Ie(e) {
  var a;
  return ((a = G[e]) == null ? void 0 : a.i18n) || "";
}
function M(e, a) {
  const r = T(a);
  if (!r)
    return [];
  if (typeof e == "number") {
    const d = e;
    if ([6, 7, 800, 801].includes(d)) {
      if (V(d))
        return u[r] || [];
      if (A(d))
        return l[r] || [];
    } else
      e = !1;
  } else typeof e != "boolean" && console.error("getGradingSystem isIndoorClimbOrBouldering 类型错误");
  return (e ? _ : p)[r] || [];
}
function R(e, a, r, {
  // 超过最大等级
  returnMaxgradeWhenOver: m = !1
} = {}) {
  const d = M(
    e,
    a
  );
  if (!d || !d.length)
    return null;
  const o = d[d.length - 1];
  if (r > o.grade && m)
    return o;
  const g = d[r];
  return g || null;
}
function v(e, a, r) {
  const m = M(
    e,
    a
  );
  if (!m)
    return null;
  let d = null;
  for (let o = 0, g = m.length; o < g; o++) {
    const c = m[o];
    if (c.commonGrade.includes(r)) {
      d = c;
      break;
    }
  }
  return d;
}
const t = {
  t: () => ""
};
let O = !1;
function Ue(e) {
  !O && e && (t.t = e, O = !0);
}
function se(e, a, r) {
  const m = e.length;
  let d = [];
  const o = r.grade, g = a.grade;
  if (o - g <= 3)
    d = [e[g], e[g + 1], e[g + 2], e[g + 3]], e[g + 3] || (d = [e[o - 3], e[o - 2], e[o - 1], e[o]]);
  else {
    const n = Math.ceil((o - g) / 3);
    n * 3 >= m ? d = [
      e[0],
      e[m - 1 - 2 * n],
      e[m - 1 - n],
      e[m - 1]
    ] : (d = [
      e[o - 3 * n],
      e[o - 2 * n],
      e[o - n],
      e[o]
    ], d[0] || (d[1].grade === 0 ? d = [e[0], e[n], e[2 * n], e[3 * n]] : d = [e[0], e[o - 2 * n], e[o - n], e[o]]));
  }
  return a = d[0], r = d[3], {
    min: a.commonGrade[a.commonGrade.length - 1],
    max: r.commonGrade[r.commonGrade.length - 1],
    ticks: d.map((n) => ({
      value: n.commonGrade[n.commonGrade.length - 1],
      text: n.gradeNameI18n ? t.t(n.gradeNameI18n) : n.gradeName
    }))
  };
}
function fe(e, { addNotSetOption: a = !0, addCustomOption: r = !1 } = {}) {
  const d = (e === 6 ? h : L).map((o) => ({
    value: o,
    label: G[o].i18n ? t.t(G[o].i18n) : ""
  }));
  return a && d.push({
    value: 0,
    label: t.t("S4313")
  }), r && d.push({
    value: "custom",
    label: t.t("T5064")
  }), d;
}
const x = [
  "S4681",
  // 视攀-8
  "S4680",
  "S4679",
  "S4678",
  "S4677",
  "S4676",
  "S4675",
  "S4674",
  "S4673",
  // 视攀
  "S4672",
  "S4671",
  "S4670",
  "S4669"
  // 视攀+4
];
function be(e) {
  const a = e - 32;
  return t.t(x[8 + a]);
}
function Se(e, a) {
  const r = G[a].name, d = (e === 6 ? u : l)[r];
  if (!d) return [];
  const o = Array.from({ length: 13 }).map((g, c) => {
    const n = x[c];
    return c < 9 ? {
      value: `1-${32 - (8 - c)}`,
      label: t.t(n)
    } : {
      value: `1-${32 + (c - 8)}`,
      label: t.t(n)
    };
  });
  return [
    {
      value: "1",
      label: t.t("S4659"),
      children: o
    },
    {
      value: "2",
      label: t.t("S4660"),
      children: d.map((g) => ({
        value: "2-" + g.grade,
        label: g.gradeName
      }))
    }
  ];
}
function Ve({
  globalGradeSystem: e,
  exerciseGradeSystem: a,
  climbConfig: r,
  sportType: m,
  val: d
}) {
  if (!B(m)) return "";
  const [o, g] = d.split("-").map((b) => parseInt(b, 10));
  if (o === 2) return "";
  const c = r.find(
    (b) => b.sportType === m
  );
  if (!c) return "";
  let n = e && e !== "custom" ? e : c.gradingSystem;
  ["custom", void 0].includes(e) && a && (n = a);
  let I = c.gradeIndex;
  n !== c.gradingSystem && (I = C({
    sportType: c.sportType,
    fromSystem: c.gradingSystem,
    toSystem: n,
    level: I
  }));
  let s = I + (g - 32);
  s < 0 && (s = 0);
  const f = R(!0, n, s, {
    returnMaxgradeWhenOver: !0
  });
  return (f == null ? void 0 : f.gradeName) || "";
}
function C({
  sportType: e,
  fromSystem: a,
  toSystem: r,
  level: m
}) {
  const d = R(e, a, m);
  if (!d) return 0;
  const o = v(
    e,
    r,
    d.commonGrade[d.commonGrade.length - 1]
  );
  return o ? o.grade : 0;
}
function Ae(e) {
  return t.t(e);
}
const Me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BOULDERING_GRADING_SYSTEM: L,
  BOULDERING_GRADING_SYSTEM_DATA: l,
  CLIMB_STYLE: F,
  CLIMB_STYLE_DICT: ie,
  GRADING_SYSTEM: E,
  GRADING_SYSTEM_DATA: p,
  GRADING_SYSTEM_VAL_DICT: G,
  INDOOR_CLIMB_BOULDERING_CHART_NAME: ue,
  INDOOR_CLIMB_BOULDERING_GRADING_SYSTEM_DATA: _,
  INDOOR_CLIMB_GRADING_SYSTEM: h,
  INDOOR_CLIMB_GRADING_SYSTEM_DATA: u,
  getDisplayHardLevelValue: Ve,
  getGradeLevelOptions: Se,
  getGradingGrade: R,
  getGradingGradeByCommonGrade: v,
  getGradingSystem: M,
  getGradingSystemI18nKey: Ie,
  getGradingSystemName: T,
  getGradingSytemOptions: fe,
  getGradingTickInfo: se,
  getOnSightI18nKey: be,
  hardLevelConvert: C,
  isBoulderingTrainingSportType: A,
  isIndoorClimbOrBoulderingTrainingSportName: le,
  isIndoorClimbOrBoulderingTrainingSportType: B,
  isIndoorClimbTrainingSportType: V,
  test_t: Ae
}, Symbol.toStringTag, { value: "Module" })), Re = [
  { value: 2, label: "m" },
  { value: 4, label: "yd" }
], De = 15, Oe = 300, K = {
  1: 25,
  2: 50,
  3: 25,
  4: 33,
  5: 33
}, pe = {
  1: 2,
  2: 2,
  3: 4,
  4: 2,
  5: 4
}, N = {
  "25M": 1,
  "50M": 2,
  "25YARD": 3,
  "33M": 4,
  "33YARD": 5,
  CUSTOM: 0
}, D = [
  { value: N["25M"], label: "25m" },
  { value: N["50M"], label: "50m" },
  { value: N["25YARD"], label: "25yard" },
  { value: N["33M"], label: "33 1/3m" },
  { value: N["33YARD"], label: "33 1/3yard" },
  { value: N.CUSTOM, i18n: "S4238" }
];
function _e(e) {
  var a;
  return (a = D.find((r) => r.value === e)) == null ? void 0 : a.label;
}
const Ee = () => D.map((e) => ({
  value: e.value,
  label: e.i18n ? t.t(e.i18n) : e.label
}));
var U = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.FREE_STROKE = 1] = "FREE_STROKE", e[e.BREAST_STROKE = 2] = "BREAST_STROKE", e[e.BACK_STROKE = 3] = "BACK_STROKE", e[e.BUTTERFLY_STROKE = 4] = "BUTTERFLY_STROKE", e[e.DRILL_LOG = 5] = "DRILL_LOG", e[e.MEDLEY = 255] = "MEDLEY", e[e.INDIVIDUAL_MEDLEY = 7] = "INDIVIDUAL_MEDLEY", e[e.DRILLS = 6] = "DRILLS", e[e.CUSTOM = 254] = "CUSTOM", e))(U || {});
const Le = {
  // 不设置
  NOT_SET: {
    nameI18n: "S4313",
    type: 0
  },
  // 自由泳
  FREE_STROKE: {
    nameI18n: "S2615",
    type: 1
  },
  // 蛙泳
  BREAST_STROKE: {
    nameI18n: "S2616",
    type: 2
  },
  // 仰泳
  BACK_STROKE: {
    nameI18n: "S2617",
    type: 3
  },
  // 蝶泳
  BUTTERFLY_STROKE: {
    nameI18n: "S2618",
    type: 4
  },
  // 打腿
  DRILL_LOG: {
    nameI18n: "H6033",
    type: 5
  },
  // 混合泳
  MEDLEY: {
    // S2619 混合泳
    // S4690 混合泳（2种以上泳姿混合）
    nameI18n: "S4690",
    name2I18n: "S2619",
    type: 255
  },
  // 个人混合泳
  INDIVIDUAL_MEDLEY: {
    // S4684 个人混合泳
    // S4689 个人混合泳（标准蝶、仰、蛙、自混合）
    nameI18n: "S4689",
    name2I18n: "S4684",
    type: 7
  },
  // 分解动作
  DRILLS: {
    nameI18n: "S4685",
    type: 6
  },
  // 自定义距离圈，不展示游姿
  CUSTOM: {
    nameI18n: "",
    type: 254
  }
}, he = [
  "FREE_STROKE",
  "BREAST_STROKE",
  "BACK_STROKE",
  "BUTTERFLY_STROKE",
  "MEDLEY",
  "INDIVIDUAL_MEDLEY",
  "DRILLS",
  "NOT_SET"
], H = () => he.map((e) => {
  const a = Le[e];
  return {
    ...a,
    nameText: t.t(a.nameI18n),
    ..."name2I18n" in a && { name2Text: t.t(a.name2I18n) }
  };
});
function Fe(e) {
  const a = H().find((r) => r.type === e);
  return (a == null ? void 0 : a.name2Text) || (a == null ? void 0 : a.nameText);
}
const Be = {
  33: 1,
  67: 2
};
function Te(e) {
  const a = e % 100;
  let r = Be[a];
  return r && (r = ` ${r}/3`), `${Math.trunc(e / 100)}${r || ""}`;
}
function i(e) {
  return [4, 5].includes(e);
}
function ve(e) {
  const a = Math.round(e / 25);
  return e = Number((a * 25).toFixed(0)), e;
}
function xe(e, a, r) {
  if (e > 1e4 && (e = 1e4), e % 100 === 0 || a === r || r === 1 && a === 3 || r === 3 && a === 1 || r === 4 && a === 5 || r === 5 && a === 4)
    return e;
  const m = K[r];
  if (i(r) && !i(a)) {
    const d = Math.round(e / m);
    e = Number((d * m + d / 3).toFixed(2));
  } else if (!i(r) && i(a)) {
    const d = Math.round(e / m);
    e = Number((d * m).toFixed(0));
  } else if ([1, 3].includes(a) && r === 2) {
    const d = Math.round(e / m);
    e = Number((d * m).toFixed(0));
  } else if (a === 0 && r !== 0) {
    const d = Math.round(e / m);
    e = Number((d * m).toFixed(0));
  }
  return e > 1e4 ? e = 1e4 : e < 25 && (e = 25), e;
}
const Ce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  POOL_LENGTH_TYPE: N,
  SWIM_STYLE_TYPE: U,
  convertDistanceValue: xe,
  convertOldDistanceValue: ve,
  customPoolLengthMax: Oe,
  customPoolLengthMin: De,
  getLabelByValue: Te,
  getPoolLengthLabelByValue: _e,
  getPoolLengthOptions: Ee,
  getSwimStyleLabelByValue: Fe,
  getSwimStyleList: H,
  poolLengthOptions: D,
  poolLengthUnitMap: pe,
  poolLengthUnitOptions: Re,
  poolLengthValueMap: K
}, Symbol.toStringTag, { value: "Module" })), He = {
  climb: Me,
  poolSwim: Ce
}, Xe = () => Math.random().toString(36).slice(2, 10);
export {
  Ke as basic,
  Xe as generateUniqueId,
  Ue as setUpT,
  He as sport
};
